import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    halfWidth: {},
    modal: {
        width: 508,
        maxHeight: 'calc(100dvh - 50px)',
        fallbacks: { maxHeight: 'calc(100vh - 50px)' },
        overflowY: 'scroll',
    },
    h2: {
        fontFamily: theme.font.secondary,
        fontSize: 24,
        lineHeight: 1.33,
        color: theme.colors.black,
        fontWeight: 'normal',
        marginBottom: theme.spacing(7),
    },
    field: {
        marginBottom: theme.spacing(6),
        '&$halfWidth': {
            width: 'calc(50% - 12px)',
        },
    },
    fieldWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
    },
    dropdown: {
        margin: 0,
    },
    buttons: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 10,
    },
    end: {
        justifyContent: 'flex-end',
    },
    button: {
        marginLeft: theme.spacing(5),
    },
    errors: {
        marginBottom: theme.spacing(4),
    },
    error: {
        backgroundColor: theme.colors.red,
        marginBottom: theme.spacing(2),
    },
}));
